module.exports = __webpack_public_path__ + "img/pieceOneImg6.eed2f27.webp";